export default __webpack_public_path__ + "static/media/moreopt.611dd2a4.svg";